export default function HighlightText({ text, search }) {
  if (!search) return text;

  const words = search
    .split(" ")
    .filter((word) => word.trim() !== "")
    .map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));

  if (words.length === 0) return text;

  const regex = new RegExp(`(${words.join("|")})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) =>
    words.some((word) => part.toLowerCase() === word.toLowerCase()) ? (
      <span key={index} style={{ backgroundColor: "yellow" }}>
        {part}
      </span>
    ) : (
      part
    )
  );
}
